/**
 * auth-service 엔드포인트 — gateway 경유(`/v1/auth/**`).
 *
 * 앱별 endpoints 레지스트리에 복사하지 말고 여기서 가져간다. web / console-web 이
 * **같은 세션**을 쓰므로 경로가 갈라지면 한쪽만 로그아웃되는 버그가 난다.
 * baseURL 은 각 앱 client 가 주입한다 — 여기엔 path 만.
 */
export const AUTH_API_VERSION = '/v1';

export const AUTH_ENDPOINTS = {
  signup: `${AUTH_API_VERSION}/auth/signup`,
  checkAvailability: `${AUTH_API_VERSION}/auth/check-availability`,
  login: `${AUTH_API_VERSION}/auth/login`,
  refresh: `${AUTH_API_VERSION}/auth/refresh`,
  logout: `${AUTH_API_VERSION}/auth/logout`,
  me: `${AUTH_API_VERSION}/auth/me`,
  verifyEmail: `${AUTH_API_VERSION}/auth/verify-email`,
  resendVerification: `${AUTH_API_VERSION}/auth/resend-verification`,
  resendVerificationAnonymous: `${AUTH_API_VERSION}/auth/resend-verification-anonymous`,
  // 로그인 화면 미인증 안내의 재발송 — 아이디·비밀번호로 계정을 특정해 가입 주소로 보낸다.
  resendVerificationByLogin: `${AUTH_API_VERSION}/auth/resend-verification/by-login`,
  // 가입정보 확인 — 미인증 계정의 가입 이메일 오타 복구(휴대폰 OTP 선행).
  signupRecoveryLookup: `${AUTH_API_VERSION}/auth/signup-recovery/lookup`,
  signupRecoveryEmail: `${AUTH_API_VERSION}/auth/signup-recovery/email`,
  requestPasswordReset: `${AUTH_API_VERSION}/auth/request-password-reset`,
  resetPassword: `${AUTH_API_VERSION}/auth/reset-password`,
  requestEmailChange: `${AUTH_API_VERSION}/auth/request-email-change`,
  confirmEmailChange: `${AUTH_API_VERSION}/auth/confirm-email-change`,
  sendPhoneOtp: `${AUTH_API_VERSION}/auth/phone/send-otp`,
  verifyPhoneOtp: `${AUTH_API_VERSION}/auth/phone/verify-otp`,
  updateMe: `${AUTH_API_VERSION}/auth/me`,
  deleteMe: `${AUTH_API_VERSION}/auth/me`,
  withdrawalPreview: `${AUTH_API_VERSION}/auth/me/withdrawal-preview`,
  changeMyPhone: `${AUTH_API_VERSION}/auth/me/phone`,
  changeMyPassword: `${AUTH_API_VERSION}/auth/me/password`,
  // 아이디 찾기 — 이메일 로그인을 없앤 뒤 자력 복구의 유일한 경로.
  findLoginIdByPhone: `${AUTH_API_VERSION}/auth/find-login-id/by-phone`,
  findLoginIdByEmail: `${AUTH_API_VERSION}/auth/find-login-id/by-email`,
  // 첫 로그인 온보딩 (Owner 가 만든 구성원 계정·구버전 이관 계정)
  onboardingState: `${AUTH_API_VERSION}/auth/me/onboarding`,
  onboardingLoginId: `${AUTH_API_VERSION}/auth/me/onboarding/login-id`,
  onboardingPassword: `${AUTH_API_VERSION}/auth/me/onboarding/password`,
  onboardingEmail: `${AUTH_API_VERSION}/auth/me/onboarding/email`,
  onboardingEmailVerify: `${AUTH_API_VERSION}/auth/me/onboarding/email/verify`,
  onboardingPhone: `${AUTH_API_VERSION}/auth/me/onboarding/phone`,
  onboardingPhoneDefer: `${AUTH_API_VERSION}/auth/me/onboarding/phone/defer`,
  // 약관 동의 — 온보딩 마지막 단계와 개정 후 재동의가 같은 경로를 쓴다.
  consents: `${AUTH_API_VERSION}/auth/me/consents`,
  // 데스크톱(XCOST) 브라우저 로그인 — 웹은 동의 화면만 쓴다(token·revoke 는 XCOST 가 직접 호출).
  desktopAuthorize: `${AUTH_API_VERSION}/auth/desktop/authorize`,
} as const;
